import { render, staticRenderFns } from "./ConfigureTwoFactorAuth.vue?vue&type=template&id=c2cbe36e&scoped=true&"
import script from "./ConfigureTwoFactorAuth.vue?vue&type=script&lang=js&"
export * from "./ConfigureTwoFactorAuth.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureTwoFactorAuth.vue?vue&type=style&index=0&id=c2cbe36e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cbe36e",
  null
  
)

export default component.exports